var memberCommonAPI = {
    formId: '1421',
    memberSchemaId: '498',
    globalUserId: getCookie('globalUserId') ? getCookie('globalUserId').replace(/"/g, "") : '',
    apiBaseUrl: window.smk_api_host,

    // 更新用户信息
    updateUserInfo: function (formData,callback) {
        // 在formData中增加 company字段 真实公司名称
        if(window.ifMatchingcompanyName){
            var company = ''
            // 循环获取 enterprise_name 字段
            for(var i = 0; i < formData.length; i++){
                if(formData[i].fieldName === 'enterprise_name'){
                    company = formData[i].value;
                    break;
                }
            }

            if(company){
                formData.push({
                    "fieldName": "company",
                    "value": company
                })
            }
        }

        var smarketMember = JSON.parse(common.getCookie('smarketMember_498'));
        postJson(solution_host + '/api/account/updateMember',{
            "tenantId":window.cateData.tenantId,
            "schemaId":window.cateData.schemaId,
            "session": smarketMember.session,
            "url": window.location.href,
            "browseInfo": window.client.browseInfo,
            "formData":formData,
            "globalUserId": getUserInfo.options.globalUserId,
            "OCSESSID": common.getCookie('OCSESSID') || '',
            "c_keyword": common.getSS('companyKey') || '',
        },function (res) {
            if (callback && typeof callback === 'function'){
                callback(res);
            }
        })
    },

    // 登录
    login: function (unique, password, smsCode, successCallback, errorCallback) {
        var params = {
            "formId": this.formId,
            "unique": unique,
            "password": password || '',
            "checkCode": smsCode,
            "loginType": baseVerif.isMobile(unique) ? "mobile" : "email",
            "url": window.location.href,
            "browseInfo": client.browseInfo,
            "globalUserId": getCookie('globalUserId') ? getCookie('globalUserId').replace(/"/g, "") : '',
            "getuserinfo": common.getUrlPara('getuserinfo') || '',
            "verify": common.getCookie('dell_wx_verify') || '',
            "utm_source": common_utmObj.utm_source || '',
            "utm_medium": common_utmObj.utm_medium || '',
            "utm_campaign": common_utmObj.utm_campaign || '',
            "utm_content": common_utmObj.utm_content || '',
            "utm_term": common_utmObj.utm_term || ''
        };
        this.api('/api/account/login',params,successCallback, errorCallback);
    },

    api: function (url , data, successCallback,errorCallback ) {
        $.ajax({
            url: url,
            method: 'POST',
            data: data,
            success:function (res) {
                if (successCallback && typeof successCallback == 'function'){
                    successCallback(res);
                }
            },
            error: function (error) {
                msg.toast('请求超时，请重试');
                if (errorCallback  && typeof errorCallback == 'function'){
                    errorCallback()
                }
            }
        })
    }
};
